// extracted by mini-css-extract-plugin
export default {"root":"Sider_root__ToKN+","formButtons":"Sider_formButtons__W4O1k","bottomButtons":"Sider_bottomButtons__owtiU"};